module.exports = __webpack_public_path__ + "img/02-hiw-cover.7d737669.png";